/**
 * _google-translate.js
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2017 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        https://www.sudimage.fr
 * @created     14/06/2017
 */

function googleTranslate() {
    new google.translate.TranslateElement({
        pageLanguage: 'fr',
        includedLanguages: 'ar,bg,bs,cs,da,de,el,en,es,et,fi,hr,hu,is,it,ja,ka,ko,nl,no,pl,pt,ro,ru,sk,sl,sq,sr,sv,tr,uk,vi,zh-CN',
        layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL},
        'google_translate_element'
    );
}